import { ProgramNames } from '../../../models/programs/Programs'
import { PROVIDER_TYPES } from '../../../models/providers/Providers'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { LTSessionTypes } from '../../sessions/constants'
import { ConsentText, ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const MEDICATION_MANAGEMENT_PROGRAM = {
  programName: ProgramNames.MedicationManagement,
  blendedCareProgramId: '1b2b8b47-4c0e-49ff-a65c-40e187360b70',
  customerPropertyId: ProgramCustomerPropertyId.blendedCareMeds,

  displayLabels: {
    default: ProgramDisplayLabels.medicationManagement,
    clientProfile: 'Meds Management',
    short: 'Meds',
    sessionSummary: 'medications management',
  },

  associatedProviderTypes: [PROVIDER_TYPES.LYRAPRESCRIBER.lyraType],
  associatedProviderModalities: ['lyraMedManagement'],

  directBookingParams: {
    clientele: PROGRAM_TAXONOMY.clientele.individual,
    treatment: PROGRAM_TAXONOMY.treatment.medicationManagement,
    partner: PROGRAM_TAXONOMY.partner.blendedCare,
    offering: PROGRAM_TAXONOMY.offering.default,
  },

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.BLENDED_CARE_MEDS],
    isFullTreatmentOption: true,
  },

  canRescheduleAppointment: false,
  selfPayEligible: false,

  sessionTypeConfig: {
    sessionType: LTSessionTypes.INITIAL_MEDS_SESSION,
    followupSessionType: LTSessionTypes.FOLLOWUP_MEDS_SESSION,
    rateStrategy: 'fixed',
  },

  consents: [
    {
      consentText: ConsentText.medicationManagementConsent,
      consentUrl: 'https://www.lyrahealth.com/bcm-agreement',
      showConsentIf: () => true,
    },
  ],

  noteContentMetadataName: {
    INITIAL_NOTE: 'bcmInitialNote',
    SESSION_NOTE: 'bcmSessionNote',
    GENERAL_NOTE: 'bcmGeneralNote',
    REFERRAL_NOTE: 'baseReferralNote',
    OLD_INITIAL_NOTE: 'medsInitialNote',
    OLD_SESSION_NOTE: 'medsSessionNote',
    OLD_GENERAL_NOTE: 'medsGeneralNote',
    OLD_REFERRAL_NOTE: 'medsReferralNote',
  },
} satisfies ProgramConfig
